import { createApiSlice } from "@common/common-slice/commonSlice";

import { CRUD_QUESTION_TYPE } from "@routes";

const apiConfig = [
  {
    name: "createQuestionType",
    method: "post",
    url: CRUD_QUESTION_TYPE,
    stateKey: "message",
  },
  {
    name: "getQuestionType",
    method: "get",
    url: CRUD_QUESTION_TYPE,
    stateKey: "questionTypeData",
  },
  {
    name: "updateQuestionType",
    method: "put",
    url: CRUD_QUESTION_TYPE,
    stateKey: "message",
  },
  {
    name: "deleteQuestionType",
    method: "delete",
    url: CRUD_QUESTION_TYPE,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    questionTypeData: [],
  },
  reducers: {
  },

  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "questionType",
  apiConfig,
  customReducers
);

const questionTypeSlice = slice;
export default questionTypeSlice.reducer;

export const {
  createQuestionType,
  getQuestionType,
  updateQuestionType,
  deleteQuestionType,
} = thunks;

export const {
  rowSelect,
} = actions;